import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconNames } from '../../constants';

@Component({
    selector: 'ui-check-icon',
    template: `<ui-svg-icon [name]="iconNames.Checkmark" class="tw-text-light-green-500 tw-align-middle"></ui-svg-icon>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CheckIconComponent {
  iconNames = IconNames;
}
